import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaStar, FaGraduationCap, FaWhatsapp, FaUserFriends } from "react-icons/fa";
import { MdVerified } from "react-icons/md";

export default function Doctor() {
  const [activeTab, setActiveTab] = useState("chief");

  const chiefDoctor = {
    name: "Dr. Sainul Abid A",
    role: "Founder & Chief Dental Surgeon",
    image: "/images/drsainul.jpeg",
    experience: "10+ Years of Experience",
    patients: "5000",
    education: "BDS",
    bio: [
      "Dr. Sainul Abid A is the Founder & Chief Dental Surgeon of Dr. Sainulabid's IQRA Multispeciality Dental Clinic, Athavanad.",
      "With over 10 years of clinical experience, he is dedicated to delivering advanced, evidence-based dental care with compassion and precision.",
      "His expertise includes dental implants, root canal treatment, cosmetic dentistry, Hollywood smile designing, teeth whitening and comprehensive family dental care.",
      "Together with an experienced team of specialists, he provides personalized, high-quality treatment for patients of all ages."
    ]
  };

  const specialistTeam = [
    { 
      name: "Dr. Fousiya KP", 
      role: "Lady Dental Surgeon", 
      specialty: "General Dentistry",
      image: "/images/drfousiya.jpeg"
    },
    { 
      name: "Dr. Rahul Narendran", 
      role: "Orthodontist & Invisalign Aligner Specialist", 
      specialty: "Braces & Aligners",
      image: "/images/drrahul.jpeg"
    },
    { 
      name: "Dr. Jinsiya", 
      role: "Lady Dental Surgeon", 
      specialty: "General Dentistry",
      image: "/images/drjinsiya.jpeg"
    },
    { 
      name: "Dr. Mohamed Asif P E", 
      role: "Oral & Maxillofacial Surgeon", 
      specialty: "Surgical Dentistry",
      image: "/images/doctor-placeholder.png"
    },
    { 
      name: "Dr. Musaffar Thoyali", 
      role: "Pedodontist", 
      specialty: "Kids Dentistry",
      image: "/images/doctor-placeholder.png"
    },
    { 
      name: "Dr. Mohamed Shafeeque P", 
      role: "Root Canal Specialist", 
      specialty: "Endodontics",
      image: "/images/doctor-placeholder.png"
    },
    { 
      name: "Dr. Ashraf CP", 
      role: "Consulting Dental Surgeon", 
      specialty: "General Dentistry",
      image: "/images/drashraf.jpeg"
    },
    { 
      name: "Dr. Yasar VPO", 
      role: "Consulting Dental Surgeon", 
      specialty: "Oral Medicine",
      image: "/images/doctor-placeholder.png"
    },
  ];

  return (
    <section id="doctor" className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-gradient-to-br from-[#F8FBFC] to-white relative overflow-hidden">
      
      <div className="absolute inset-0">
        <motion.div
          animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3] }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
          className="absolute -top-40 -left-40 w-80 h-80 bg-teal-100/30 rounded-full blur-3xl"
        />
        <motion.div
          animate={{ scale: [1, 1.3, 1], opacity: [0.2, 0.4, 0.2] }}
          transition={{ duration: 10, repeat: Infinity, ease: "easeInOut", delay: 1 }}
          className="absolute -bottom-40 -right-40 w-96 h-96 bg-teal-50/40 rounded-full blur-3xl"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        
        <div className="text-center mb-12 sm:mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 bg-teal-50/80 backdrop-blur-sm px-4 py-2 rounded-full mb-4 border border-teal-100"
          >
            <span className="w-1.5 h-1.5 bg-teal-500 rounded-full animate-pulse"></span>
            <MdVerified className="text-teal-600 text-sm" />
            <span className="text-teal-600 text-xs sm:text-sm font-semibold tracking-wide">EXPERT TEAM</span>
            <span className="w-1.5 h-1.5 bg-teal-500 rounded-full animate-pulse"></span>
          </motion.div>
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
            className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#1E293B] mb-2"
          >
            Meet Our Expert Dental Team
          </motion.h2>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.15 }}
            viewport={{ once: true }}
            className="text-teal-600 text-sm sm:text-base font-medium"
          >
            Founder & Chief Dental Surgeon together with experienced visiting specialists providing complete family dental care.
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, width: 0 }}
            whileInView={{ opacity: 1, width: "5rem" }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="h-1 bg-gradient-to-r from-[#2CA6B1] to-[#4FD1C5] mx-auto rounded-full mt-3"
          />
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            viewport={{ once: true }}
            className="text-gray-500 text-sm sm:text-base max-w-2xl mx-auto mt-4"
          >
            Meet our experienced team of dental specialists providing advanced, compassionate and patient-focused dental care at Dr. Sainulabid's IQRA Multispeciality Dental Clinic, Athavanad, Malappuram.
          </motion.p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-12">
          <button
            onClick={() => setActiveTab("chief")}
            className={`px-5 sm:px-6 py-1.5 sm:py-2 rounded-full font-semibold text-sm sm:text-base transition-all duration-300 ${
              activeTab === "chief"
                ? "bg-gradient-to-r from-[#2CA6B1] to-[#4FD1C5] text-white shadow-lg"
                : "bg-white text-[#64748B] border border-gray-200 hover:border-teal-300"
            }`}
          >
            Chief Dental Surgeon
          </button>
          <button
            onClick={() => setActiveTab("team")}
            className={`px-5 sm:px-6 py-1.5 sm:py-2 rounded-full font-semibold text-sm sm:text-base transition-all duration-300 ${
              activeTab === "team"
                ? "bg-gradient-to-r from-[#2CA6B1] to-[#4FD1C5] text-white shadow-lg"
                : "bg-white text-[#64748B] border border-gray-200 hover:border-teal-300"
            }`}
          >
            Specialist Team
          </button>
        </div>

        {activeTab === "chief" && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl overflow-hidden border border-white/50"
          >
            <div className="relative bg-gradient-to-br from-teal-100 to-teal-50 p-6 sm:p-8 flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-[#2CA6B1] to-[#4FD1C5] rounded-full blur-2xl opacity-40"></div>
                <img
                  src={chiefDoctor.image}
                  alt={chiefDoctor.name + " - Founder & Chief Dental Surgeon at IQRA Multispeciality Dental Clinic, Athavanad"}
                  className="relative w-56 h-56 sm:w-64 sm:h-64 md:w-80 md:h-80 rounded-full object-cover border-4 border-white shadow-2xl"
                  onError={(e) => {
                    e.target.src = "/images/doctor-placeholder.png";
                  }}
                />
                <div className="absolute -bottom-2 -right-2 bg-[#2CA6B1] rounded-full p-1.5 sm:p-2 border-4 border-white">
                  <MdVerified size={16} className="sm:text-[20px] text-white" />
                </div>
              </div>
            </div>

            <div className="px-6 py-8 sm:p-8">
              <h3 className="flex items-center gap-2 text-2xl sm:text-3xl font-bold text-[#1E293B] mb-1">
                {chiefDoctor.name}
                <MdVerified className="text-teal-500 text-xl" />
              </h3>
              <p className="text-teal-600 font-semibold text-sm sm:text-base mb-4">{chiefDoctor.role}</p>
              
              <div className="flex flex-wrap gap-3 mb-4 sm:mb-6">
                <div className="flex items-center gap-1.5 sm:gap-2 bg-teal-50 px-3 sm:px-4 py-1 sm:py-2 rounded-full">
                  <FaStar className="text-yellow-500 text-xs sm:text-sm" />
                  <span className="text-xs sm:text-sm">{chiefDoctor.experience}</span>
                </div>
                <div className="flex items-center gap-1.5 sm:gap-2 bg-teal-50 px-3 sm:px-4 py-1 sm:py-2 rounded-full">
                  <FaGraduationCap className="text-teal-600 text-xs sm:text-sm" />
                  <span className="text-xs sm:text-sm">{chiefDoctor.education}</span>
                </div>
                <div className="flex items-center gap-1.5 sm:gap-2 bg-teal-50 px-3 sm:px-4 py-1 sm:py-2 rounded-full">
                  <FaUserFriends className="text-teal-600 text-xs sm:text-sm" />
                  <span className="text-xs sm:text-sm">{chiefDoctor.patients}+ Satisfied Patients</span>
                </div>
              </div>

              <div className="border-t border-gray-100 my-6"></div>

              <div className="space-y-3 mb-6">
                {chiefDoctor.bio.map((paragraph, idx) => (
                  <p key={idx} className="text-gray-600 text-[15px] leading-7">
                    {paragraph}
                  </p>
                ))}
              </div>

              <a
                href="#contact"
                className="inline-flex items-center gap-1.5 sm:gap-2 bg-gradient-to-r from-[#2CA6B1] to-[#4FD1C5] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-xl font-semibold text-sm sm:text-base hover:scale-105 transition-transform shadow-lg"
              >
                <FaWhatsapp className="text-sm sm:text-base" />
                Book Your Appointment
              </a>
            </div>
          </motion.div>
        )}

        {activeTab === "team" && (
          <>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6"
            >
              {specialistTeam.map((doctor, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: idx * 0.05 }}
                  viewport={{ once: true }}
                  className="group bg-white/80 backdrop-blur-sm rounded-xl p-4 sm:p-6 text-center shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 hover:border-teal-300 border border-gray-100/50"
                >
                  {/* ✅ Passport size image with small corner curve */}
                  <div className="w-24 h-28 sm:w-28 sm:h-32 md:w-32 md:h-36 mx-auto mb-3 sm:mb-4 overflow-hidden rounded-md bg-gradient-to-br from-teal-100 to-teal-50 flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-md">
                    <img
                      src={doctor.image}
                      alt={doctor.name + " - " + doctor.role + " at IQRA Multispeciality Dental Clinic, Athavanad"}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.src = "/images/doctor-placeholder.png";
                      }}
                    />
                  </div>
                  <h4 className="font-bold text-[#1E293B] text-sm sm:text-base mb-0.5">{doctor.name}</h4>
                  <p className="text-teal-600 text-[11px] sm:text-xs font-medium mb-1.5">{doctor.role}</p>
                  <p className="inline-flex items-center justify-center bg-teal-50 text-teal-700 px-3 py-1 rounded-full text-xs font-semibold mt-2">
                    {doctor.specialty}
                  </p>
                </motion.div>
              ))}
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="mt-10 text-center max-w-2xl mx-auto"
            >
              <p className="text-gray-500 text-sm sm:text-base leading-relaxed">
                Our specialist team works together to provide comprehensive dental care using modern technology and personalized treatment plans.
              </p>
            </motion.div>
          </>
        )}
      </div>
    </section>
  );
}